import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { projectsData } from '../data';

const ProjectDetails = () => {
    const [project, setProject] = useState({});
    const { id } = useParams();
    useEffect(() => {
        const newProject = projectsData.find(p => p.id === id);
        setProject(newProject);
    }, [id])
    return (
        <section id='details' className='bg-tertiary'>
            <div className='bg-black min-h-[82vh] pt-40 pb-28'>
                <div>
                    {/* <!-- component --> */}
                    <div class="h-screen my-20 flex justify-center items-center bg-slate-900 ">
                        <div class="bg-slate-800 text-white rounded-lg w-full mx-5 md:w-[40rem]  space-y-6 p-10">
                            {/* <!-- header --> */}
                            <div class="flex space-x-6 items-center text-center ">
                                
                                <div class="mx-auto">
                                    <div class="text-center">
                                        <h2 class="text-base text-4xl mb-2">{project.name}</h2>
                                        <div class="  text-sm text-slate-400">{project.category}</div>
                                    </div>
                                </div>
                            </div>
                            {/* <!--content--> */}
                            <div>
                                <p class="text-sm leading-6 text-slate-300">
                                    {project.description}
                                </p>
                                <p class="text-sm leading-6 text-slate-300">
                                    Project Details : 
                                </p>
                                <ul className='text-sm leading-6 text-slate-300'>
                                    <li>- {project.li1}</li>
                                    <li>- {project.li2}</li>
                                    <li>- {project.li3}</li>
                                    <li>- {project.li4}</li>
                                    <li>- {project.li5}</li>
                                </ul>
                            </div>


                            {/* <!-- image grid--> */}


                            <div class="grid grid-cols-6 col-span-2   gap-2  ">
                                <div class=" overflow-hidden rounded-xl col-span-3 max-h-[14rem]">
                                    <img class="h-full w-full object-cover "
                                        src={project.image}
                                        alt="" />
                                </div>
                                <div class=" overflow-hidden rounded-xl col-span-3 max-h-[14rem]">
                                    <img class="h-full w-full object-cover  "
                                        src={project.image1}
                                        alt="" />
                                </div>
                                <div class=" overflow-hidden rounded-xl col-span-6 max-h-[10rem]">
                                    <img class="h-full w-full object-cover "
                                        src={project.image2}
                                        alt="" />
                                </div>
                                <div class=" overflow-hidden rounded-xl col-span-2 max-h-[10rem]">
                                    
                                </div>
                                <div class="relative overflow-hidden rounded-xl col-span-2 max-h-[10rem]">
                                    
                                </div>
                            </div>

                            {/* <!--        comments--> */}

                            <div class="flex justify-between pt-5">
                                {
                                    project.liveSite && <button className='btn btn-md bg-accent rounded-lg text-black'><a href={project.liveSite} target='_blank'>Live Site</a></button>
                                }
                                {
                                    project.githubClient && <button className='btn btn-md bg-accent rounded-lg text-black'><a href={project.githubClient} target='_blank'>GitHub Client Site</a></button>
                                }
                                {
                                    project.githubServer && <button className='btn btn-md bg-accent rounded-lg text-black'><a href={project.githubServer} target='_blank'>GitHub Server Site</a></button>
                                }

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectDetails;